<div class="card-div" id="personalDetailsCard">
    <div class="card-div-inner">
        <div class="side-tab d-md-flex d-none" id="helpTab">
            <div class="side-tab-list">
                <ul>
                    <li class="side-tab-list-item active" onclick="sideTabItemClick(this);"><span>Online check-in</span>
                    </li>
                    <li class="side-tab-list-item" onclick="sideTabItemClick(this);"><span>TSA Pre</span></li>
                    <li class="side-tab-list-item" onclick="sideTabItemClick(this);"><span>Separating Payment</span>
                    </li>
                    <li class="side-tab-list-item" onclick="sideTabItemClick(this);"><span>Galllop Cash</span></li>
                </ul>
            </div>

            <div class="side-tab-content-list">
                <div class="side-tab-content active">
                    <div class="side-tab-content-header">
                        <h3>Online check-in</h3>
                    </div>
                    <div class="side-tab-content-data">
                        <div class="side-tab-content-block">
                            <h4>Will I continue to get upgrades when Trip does check-in for me? </h4>
                            <p>Yes. If you are a frequent flyer Trip will send requests for free upgrades at the time of
                                check-in and will be sure to upgrade you when possible. However, since upgrades are
                                determined by the airlines, we cannot guarantee an upgrade for every flight. If you
                                would like to use your points to upgrade, Trip can help you with that as well. </p>
                        </div>
                        <div class="side-tab-content-block">
                            <h4>How will you know if I need to check bags or not? </h4>
                            <p>Trip will check in with you about 48 hours prior to your departure. Just let Trip know if
                                you have any special requests such as seat upgrades, checked bags, etc. and Trip will
                                take care of them for you.</p>
                        </div>
                        <div class="side-tab-content-block">
                            <h4>Do I always get the boarding passes after you check-in? </h4>
                            <p>For domestic flight check-in you will always receive your boarding passes after Trip
                                checks you in. However, for international flights, airlines often ask for physical
                                verification of documents such as your visa, passport, biometrics, etc. In such cases,
                                you will only be able receive your boarding passes at the airport.</p>
                        </div>
                    </div>
                </div>

                <div class="side-tab-content active">
                    <div class="side-tab-content-header">
                        <h3>TSA Pre</h3>
                    </div>
                    <div class="side-tab-content-data">
                        <div class="side-tab-content-block">
                            <h4>What do I need to know to make sure I get TSA Pre when I book with you? </h4>
                            <p>Please make sure that your title, first/middle/last name and DOB are exactly same as they
                                are on your Known Traveler Number document. If there is any mismatch, you won’t get a
                                TSA Pre. </p>
                        </div>
                        <div class="side-tab-content-block">
                            <h4>How do I confirm I have a TSA Pre for my upcoming flight? </h4>
                            <p>We make sure that your KTN is communicated to the airlines through our booking system. We
                                also call the airlines to double verify your KTN as provided by you. If everything is
                                fine, you should see “TSA Pre” on your boarding passes after you check-in. If there are
                                any issues, our agents will reach out to you to make any requirement corrections and are
                                ready to help you 24x7 on email or text. </p>
                        </div>

                        <div class="side-tab-content-block">
                            <h4>If I am TSA Pre eligible, am I guaranteed expedited screening? </h4>
                            <p>No, TSA uses unpredictable security measures, both seen and unseen, throughout the
                                airport. All travelers will be screened, and no individual is guaranteed expedited
                                screening.</p>
                        </div>
                        <div class="side-tab-content-block">
                            <h4>Who controls whether I will get TSA Pre or not? </h4>
                            <p>TSA controls. The best {{getBrandName()}} can do is to make sure that your title, name,
                                KTN and DOB are correctly passed to airlines’ reservation system. We double check this
                                critical information and guarantee ZERO error from our system. </p>
                        </div>

                        <div class="side-tab-content-block">
                            <h4>How do I apply for a TSA Pre? </h4>
                            <p>You can visit https://www.tsa.gov/ to check the fees and eligibility criteria. </p>
                        </div>
                    </div>
                </div>

                <div class="side-tab-content active">
                    <div class="side-tab-content-header">
                        <h3>Separating Payment</h3>
                    </div>
                    <div class="side-tab-content-data">
                        <div class="side-tab-content-block">
                            <h4>When booking travel for guests can they purchase a ticket under my account? </h4>
                            <p>We send an email to enter credit card information or call for manual entry</p>
                        </div>
                    </div>
                </div>

                <div style="display: none" class="side-tab-content active">
                    <div class="side-tab-content-header">
                        <h3>GallopCash</h3>
                    </div>
                    <div class="side-tab-content-data">
                        <div class="side-tab-content-block">
                            <h4>How do I check my GallopCash balance? </h4>
                            <p>You can login to your profile and check your current GallopCash balance. </p>
                        </div>
                        <div class="side-tab-content-block">
                            <h4>How is GallopCash earning calculated?</h4>
                            <p>The GallopCash is calculated on the amount you pay with your credit/debit card for
                                booking your travel (flight/hotel). For example, if $120 is the total amount, and you
                                paid $100 with card and $20 with GallopCash balance, you will earn 5% GallopCash on $100
                                i.e. $5. </p>
                        </div>
                        <div class="side-tab-content-block">
                            <h4>When will my account be credited? </h4>
                            <p>Within 48 hours after your travel is completed. For example, if your last flight lands on
                                Monday at 12 PM, you will receive a credit of applicable GallopCash by 12 PM on
                                Wednesday. </p>
                        </div>
                        <div class="side-tab-content-block">
                            <h4>Are there any restrictions on redeeming GallopCash?</h4>
                            <p>There are no restrictions to redeem GallopCash on any purchases made through Gallop. You
                                can redeem it for any flight and hotel booking or for purchasing ancillary services such
                                as EarlyBird check-in, premium economy seats, checked bags, etc. But unfortunately, you
                                cannot redeem it for postpaid car rentals as you will be required to pay directly at the
                                rental service station. </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="accordian help-accordian d-block d-md-none">
            <div class="accord help-accord">
                <div class="accord-header help-accord-header" onclick="openContent(this, {hideOther: true});">
                    <h4>Online check-in</h4>
                </div>
                <div class="accord-content help-accord-content">
                    <div class="side-tab-content-block">
                        <h4>Will I continue to get upgrades when Trip does check-in for me? </h4>
                        <p>Yes. If you are a frequent flyer Trip will send requests for free upgrades at the time of
                            check-in and will be sure to upgrade you when possible. However, since upgrades are
                            determined by the airlines, we cannot guarantee an upgrade for every flight. If you would
                            like to use your points to upgrade, Trip can help you with that as well. </p>
                    </div>
                    <div class="side-tab-content-block">
                        <h4>How will you know if I need to check bags or not? </h4>
                        <p>Trip will check in with you about 48 hours prior to your departure. Just let Trip know if you
                            have any special requests such as seat upgrades, checked bags, etc. and Trip will take care
                            of them for you.</p>
                    </div>
                    <div class="side-tab-content-block">
                        <h4>Do I always get the boarding passes after you check-in? </h4>
                        <p>For domestic flight check-in you will always receive your boarding passes after Trip checks
                            you in. However, for international flights, airlines often ask for physical verification of
                            documents such as your visa, passport, biometrics, etc. In such cases, you will only be able
                            receive your boarding passes at the airport.</p>
                    </div>
                </div>
            </div>

            <div class="accord help-accord">
                <div class="accord-header help-accord-header" onclick="openContent(this, {hideOther: true});">
                    <h4>TSA Pre</h4>
                </div>
                <div class="accord-content help-accord-content">
                    <div class="side-tab-content-block">
                        <h4>What do I need to know to make sure I get TSA Pre when I book with you? </h4>
                        <p>Please make sure that your title, first/middle/last name and DOB are exactly same as they are
                            on your Known Traveler Number document. If there is any mismatch, you won’t get a TSA Pre.
                        </p>
                    </div>
                    <div class="side-tab-content-block">
                        <h4>How do I confirm I have a TSA Pre for my upcoming flight? </h4>
                        <p>We make sure that your KTN is communicated to the airlines through our booking system. We
                            also call the airlines to double verify your KTN as provided by you. If everything is fine,
                            you should see “TSA Pre” on your boarding passes after you check-in. If there are any
                            issues, our agents will reach out to you to make any requirement corrections and are ready
                            to help you 24x7 on email or text. </p>
                    </div>
                    <div class="side-tab-content-block">
                        <h4>If I am TSA Pre eligible, am I guaranteed expedited screening? </h4>
                        <p>No, TSA uses unpredictable security measures, both seen and unseen, throughout the airport.
                            All travelers will be screened, and no individual is guaranteed expedited screening.</p>
                    </div>
                    <div class="side-tab-content-block">
                        <h4>Who controls whether I will get TSA Pre or not? </h4>
                        <p>TSA controls. The best {{getBrandName()}} can do is to make sure that your title, name, KTN
                            and DOB are correctly passed to airlines’ reservation system. We double check this critical
                            information and guarantee ZERO error from our system. </p>
                    </div>
                    <div class="side-tab-content-block">
                        <h4>How do I apply for a TSA Pre? </h4>
                        <p>You can visit https://www.tsa.gov/ to check the fees and eligibility criteria. </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>